import { render, staticRenderFns } from "./ShopEditQuery.vue?vue&type=template&id=3150c73e&scoped=true&"
import script from "./ShopEditQuery.vue?vue&type=script&lang=js&"
export * from "./ShopEditQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3150c73e",
  null
  
)

export default component.exports